import { Card, Col, Row } from 'antd'
import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { useTheme } from 'styled-components'
import ResultDetail from '../ResultDetail'

const ResultComparison: FC = () => {
  const { resultIdA, resultIdB } = useParams<Record<string, string>>()
  const theme = useTheme()

  return (
    <Row gutter={theme.spacing.spacing24}>
      <Col span={12}>
        <Card className='shadow'>
          <ResultDetail
            id={resultIdA}
            title={`Result ${resultIdA}`}
            wideBatteryCharts
            hideComments
          />
        </Card>
      </Col>
      <Col span={12}>
        <Card className='shadow'>
          <ResultDetail
            id={resultIdB}
            title={`Result ${resultIdB}`}
            wideBatteryCharts
            hideComments
          />
        </Card>
      </Col>
    </Row>
  )
}

export default ResultComparison
